import React from 'react';
import { ShieldAlert } from 'lucide-react';

const NoPermissions: React.FC = () => {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
          <ShieldAlert className="h-6 w-6 text-amber-700 dark:text-amber-300" />
        </div>
        <h1 className="mb-2 text-2xl font-semibold text-foreground">Acceso restringido</h1>
        <p className="text-sm text-muted-foreground">
          Tu cuenta no tiene permisos asignados. Contacta al administrador.
        </p>
      </div>
    </div>
  );
};

export default NoPermissions;
